import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React from 'react';
import { useCatalog, CatalogStatus } from '../context/CatalogContext';
export default function SiteContent() {
  __useLocale();
  const {
    content = {},
    loading,
    error
  } = useCatalog();
  return <div className="max-w-6xl mx-auto px-4" dir={__direction()}>{__tr([['news', "الأخبار"], ['faq', "الأسئلة الشائعة"], ['terms', "الشروط والأحكام"], ['privacy', "سياسة الخصوصية"]].map(([key, title]) => <section id={key} key={key} className="py-10 scroll-mt-20"><h2 className="text-2xl font-bold mb-4">{__tr(title)}</h2>{__tr(loading || error ? <CatalogStatus /> : <p className="whitespace-pre-wrap text-gray-600">{__tr(__localizedField(content, key) || "لم تتم إضافة محتوى لهذا القسم بعد.")}</p>)}</section>))}</div>;
}
